module.exports = __webpack_public_path__ + "static/media/SPMS_CI_Logo.e0008d2a.png";